import React from "react";
import Icon from "components/AppIcon";

const WelcomeSection = () => {
  return (
    <div className="text-center mb-12">
      <div className="flex items-center justify-center space-x-4 mb-6">
        <div className="w-16 h-16 bg-primary rounded-xl flex items-center justify-center shadow-lg">
          <Icon name="Zap" size={32} color="white" />
        </div>
        <div className="text-left">
          <h1 className="text-3xl font-bold text-text-primary">VTO Demo</h1>
          <p className="text-lg text-text-secondary">
            Demo Platform for VTO Integration
          </p>
        </div>
      </div>

      <div className="max-w-2xl mx-auto">
        <p className="text-lg text-text-secondary mb-4">
          A dedicated platform to showcase and test Virtual Try-On experiences
          across all partner e-commerce stores — built specifically for internal
          teams to run demos, perform QA, and validate integrations with ease.
        </p>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-8 justify-center">
          <div className="flex flex-col items-center p-4">
            <div className="w-12 h-12 bg-primary-100 rounded-lg flex items-center justify-center mb-3">
              <Icon name="Layers" size={24} className="text-primary" />
            </div>
            <h3 className="font-medium text-text-primary mb-1">
              Demo Multiple Stores
            </h3>
            <p className="text-sm text-text-secondary text-center">
              Explore and showcase Virtual Try-On across various e-commerce
              platforms in one place
            </p>
          </div>

          <div className="flex flex-col items-center p-4">
            <div className="w-12 h-12 bg-secondary-100 rounded-lg flex items-center justify-center mb-3">
              <Icon name="Activity" size={24} className="text-secondary-600" />
            </div>
            <h3 className="font-medium text-text-primary mb-1">
              Live VTO Experience
            </h3>
            <p className="text-sm text-text-secondary text-center">
              Quickly load products and try on accessories in real time to
              validate integration and performance
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WelcomeSection;
